<div class="fixed-plugin">
    <div class="dropdown">
        <a href="#" data-toggle="dropdown">
        <i class="fa fa-cog fa-2x"> </i>
        </a>
        <ul class="dropdown-menu">
            <li class="header-title">Configuration</li>
            <li class="adjustments-line">
                <a href="javascript:void(0)" class="switch-trigger">
                    <p *ngIf="isPages()">Sidebar Image</p>
                    <p *ngIf="!isPages()"> Background Image</p>
                    <bSwitch
                      [switch-on-color]="'primary'"
                      [(ngModel)]="state"
                      [ngClass]="['switch','switch-sidebar-image']"
                      (changeState)="onChange($event)">
                    </bSwitch>
                    <div class="clearfix"></div>
                </a>
            </li>
			<li class="adjustments-line" *ngIf="isPages()">
                <a href="javascript:void(0)" class="switch-trigger">
                    <p>Sidebar Mini</p>
                    <bSwitch
                      [switch-on-color]="'primary'"
                      [ngClass]="['switch','switch-sidebar-mini']"
                      (changeState)="onChange1($event)">
                    </bSwitch>
                    <div class="clearfix"></div>
                </a>
            </li>
			<li class="adjustments-line" *ngIf="isPages()">
                <a href="javascript:void(0)" class="switch-trigger">
                    <p>Fixed Navbar</p>
                    <bSwitch
                      [switch-on-color]="'primary'"
                      [ngClass]="['switch','switch-navbar-fixed']"
                      (changeState)="onChange2($event)">
                    </bSwitch>
                    <div class="clearfix"></div>
                </a>
            </li>
            <li class="adjustments-line">
                <a href="javascript:void(0)" class="switch-trigger">
                    <p>Filters</p>
                    <div class="pull-right">
                        <span class="badge filter" data-color="black"></span>
                        <span class="badge filter badge-azure" data-color="azure"></span>
                        <span class="badge filter badge-green" data-color="green"></span>
                        <span class="badge filter badge-orange" data-color="orange"></span>
                        <span class="badge filter badge-red active" data-color="red"></span>
                        <span class="badge filter badge-purple" data-color="purple"></span>
                    </div>
                    <div class="clearfix"></div>
                </a>
            </li>
            <li class="header-title">Sidebar Images</li>
            <li>
                <a class="img-holder switch-trigger" href="javascript:void(0)">
                    <img src="../../../assets/img/full-screen-image-1.jpg">
                </a>
            </li>
            <li>
                <a class="img-holder switch-trigger" href="javascript:void(0)">
                    <img src="../../../assets/img/full-screen-image-2.jpg">
                </a>
            </li>
            <li class="active">
                <a class="img-holder switch-trigger" href="javascript:void(0)">
                    <img src="../../../assets/img/full-screen-image-3.jpg">
                </a>
            </li>
            <li>
                <a class="img-holder switch-trigger" href="javascript:void(0)">
                    <img src="../../../assets/img/full-screen-image-4.jpg">
                </a>
            </li>

        </ul>
    </div>
</div>
